import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { translate } from 'react-i18next';

import Position from './Position';
import Scale from './Scale';
import Size from './Size';
import Tag from './Tag';
import ImageLanguage from './Language';

const Container = styled.div`
	padding: 32px 0 0;
`;

const InfoWrapper = styled.div`

`;

const InfoLabel = styled.p`
	font-size: 12px;
	color: #9B9B9B;
	margin: 0 0 8px;
`;

const InfoP = styled.p`
	color: #787878;
	font-size: 14px;
	margin: 0 0 8px;
	word-wrap: break-word;
`;

const ImageInfo = ({ label, info }) => (
	<InfoWrapper>
		<InfoLabel>{label}</InfoLabel>
		<InfoP>{info}</InfoP>
	</InfoWrapper>
)

ImageInfo.propTypes = {
	label: PropTypes.string,
	info: PropTypes.string,
}

const ImageAdjustment = props => {
	const { t } = props;
	const showDescription = props.name !== props.description;

	return (
		<Container>
			<ImageInfo label={t('controls/image/image/name')} info={props.name} />
			{
				showDescription &&
				<ImageInfo label={t('controls/image/image/description')} info={props.description} />
			}
			<Tag
				tag={props.tag ? true : false}
				tagAlternateText={props.tagAlternateText || ''}
				changesHandler={props.changesHandler}
			/>
			<Position position={props.position} changesHandler={props.changesHandler} />
			<Scale scale={props.scale} changesHandler={props.changesHandler} />
			<Size size={props.size} changesHandler={props.changesHandler} />
			<ImageLanguage imageLanguage={props.imageLanguage} changesHandler={props.changesHandler} />
		</Container>
	)
}

ImageAdjustment.propTypes = {
	t: PropTypes.func,
	id: PropTypes.string,
	name: PropTypes.string,
	description: PropTypes.string,
	conversions: PropTypes.shape({
		large: PropTypes.string,
		medium: PropTypes.string,
		small: PropTypes.string,
		min: PropTypes.string,
		xs: PropTypes.string,
	}),
	position: PropTypes.arrayOf(PropTypes.number),
	size: PropTypes.oneOf(['cover', 'contain']),
	imageLanguage: PropTypes.oneOf([false, 'fi', 'en']),
	scale: PropTypes.number,
	tag: PropTypes.any,
	changesHandler: PropTypes.func,
}

export default translate('translations')(ImageAdjustment)
